import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { BusienssControlNames, GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import WebDesigner from "../WebDesigner";

export default class BusinessDailyDeals extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessDailyDeals;
        this.displayName = "Daily Deals";
        this.dropList = defaultDropList;
        this.vagaroLink = "https://www.vagaro.com/merchants/settings/thingswesell/deals"
        this.resizeType = ResizeableType.All;
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation,"dailyDealLayout"];
        this.editList = [...this.primaryEditAttributes, ...CreateAttributeList(true, true, true, true, false,false,false)];
        this.contentEditable = false;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" viewBox="0 0 448 512"><path d="M197.5 32c17 0 33.3 6.7 45.3 18.7l176 176c25 25 25 65.5 0 90.5L285.3 450.7c-25 25-65.5 25-90.5 0l-176-176C6.7 262.7 0 246.5 0 229.5V80C0 53.5 21.5 32 48 32H197.5zM48 229.5c0 4.2 1.7 8.3 4.7 11.3l176 176c6.2 6.2 16.4 6.2 22.6 0L384.8 283.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-3-3-7.1-4.7-11.3-4.7H48V229.5zM112 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" /></svg>
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("dailyDealLayout", "Layout", "", AttributeInputType.SelectField, [
            { label: "Default", value: "1" },
            { label: "Wrapped", value: "2" },
        ]),
        
        ]
    }


    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {

        const atts = GetNodeDomAttributes("v-daily-deals overflow-auto flex-row gap-large align-start max-100 relative vb-control ", component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, "dailyDealLayout", "1");

        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        if (!isEditor) {

            return <BusinessPlaceHolder node={component} dataKey={BusienssControlNames.dailyDeals} layout={layout} classNames={atts.className} />
        }
        return (
            <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout} dataKey={BusienssControlNames.dailyDeals} node={component} userContext={siteData} />
            </div>
        )
    }
}